import React, { useState } from 'react';
import { Venue } from '@/types';
import { VenueList } from './VenueList';
import { VenueEditor } from './VenueEditor';
import { makeNewVenue } from './venueUtils';

interface VenuesTabProps {
  canEdit: boolean;
}

export const VenuesTab: React.FC<VenuesTabProps> = ({ canEdit }) => {
  const [editingVenue, setEditingVenue] = useState<Venue | null>(null);
  const [editingTab, setEditingTab] = useState<'details' | 'schedule'>('details');

  const openEditor = (venue: Venue, tab: 'details' | 'schedule' = 'details') => {
    setEditingVenue(venue);
    setEditingTab(tab);
  };

  return (
    <div className="animate-fade-in">
      {editingVenue && (
        <VenueEditor
          venue={editingVenue}
          initialTab={editingTab}
          onClose={() => setEditingVenue(null)}
          onSaved={() => setEditingVenue(null)}
        />
      )}

      <VenueList
        canEdit={canEdit}
        onEditDetails={(venue) => openEditor(venue, 'details')}
        onEditSchedule={(venue) => openEditor(venue, 'schedule')}
        onAddNew={() => openEditor(makeNewVenue(), 'details')}
      />
    </div>
  );
};
